import { PoStorageService } from "@po-ui/ng-storage";

export interface IFiltroListaPedidoCompraPainelAprovacao {

    lastSetDefault: Date;
    DC7EMISSAO_DE: Date | undefined;
    DC7EMISSAO_ATE: Date | undefined;
    CCRNUM: string;
    CCRSTATUS: string;
    CC7CC: string | Array<string>;
    CFORNECEDORLOJA: string;
    page: number;
    pageSize: number;
}

export class FiltroListaPedidoCompraPainelAprovacao {

    dados: IFiltroListaPedidoCompraPainelAprovacao;
    storageName: string;
    constructor(private poStorageService: PoStorageService, storageName: string){
        this.dados = this.setDefault();
        this.storageName = storageName;

        this.poStorageService.get(this.storageName).then((filtro: IFiltroListaPedidoCompraPainelAprovacao) => {
            if (filtro){
                const {
                    lastSetDefault,
                    DC7EMISSAO_DE,
                    DC7EMISSAO_ATE,
                    CC7CC,
                } = filtro;
                if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
                    this.dados = this.setDefault();
                } else {
                    this.dados = {
                        ...filtro,
                        lastSetDefault: new Date(lastSetDefault),
                        DC7EMISSAO_DE: DC7EMISSAO_DE ? new Date(DC7EMISSAO_DE) : undefined,
                        DC7EMISSAO_ATE: DC7EMISSAO_ATE ? new Date(DC7EMISSAO_ATE) : undefined,
                        CC7CC: CC7CC?.length ? CC7CC : CC7CC.toString(),
                    }
                }
            }
        })
    }
    public setDefault = (): IFiltroListaPedidoCompraPainelAprovacao => {
        return {
            lastSetDefault: new Date(),
            DC7EMISSAO_DE: this.getData(-15),
            DC7EMISSAO_ATE: new Date(),
            CCRNUM: '',
            CCRSTATUS: '02',
            CC7CC: [],
            CFORNECEDORLOJA:  '',
            page: 0,
            pageSize: 20,
        }
    }
    public setStorage = (): void => {
        this.poStorageService.set(this.storageName, this.dados);
    }
    public getData = (dias: number): Date => {
        const dataDe = new Date();
        dataDe.setDate(dataDe.getDate()+dias);
        return dataDe;
    }
    
}